import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 88.552 77.483',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      className="icon"
      d="M80.25,70.741H8.3a8.3,8.3,0,1,0,0,16.6H80.25a8.3,8.3,0,1,0,0-16.6Zm2.767,22.138H5.534a2.767,2.767,0,0,0-2.767,2.767v2.767a11.069,11.069,0,0,0,11.069,11.069H74.716A11.069,11.069,0,0,0,85.785,98.414V95.647A2.767,2.767,0,0,0,83.017,92.879ZM10.142,65.207H78.41c5.979,0,9.447-7.593,6.022-13.124C77.483,40.855,62.185,32.017,44.276,32c-17.908.017-33.207,8.855-40.156,20.082C.692,57.613,4.163,65.207,10.142,65.207ZM66.414,45.836A2.767,2.767,0,1,1,63.647,48.6,2.767,2.767,0,0,1,66.414,45.836ZM44.276,40.3a2.767,2.767,0,1,1-2.767,2.767A2.767,2.767,0,0,1,44.276,40.3ZM22.138,45.836A2.767,2.767,0,1,1,19.371,48.6,2.767,2.767,0,0,1,22.138,45.836Z"
      transform="translate(0 -32)"
      fill={fill}
    />
  </svg>
);

export default SVG;
